export default "__VITE_ASSET__kRDBJDIJ__"